import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.6 6.333a4.733 4.733 0 1 1 8.134 3.293.605.605 0 0 0-.11.11A4.733 4.733 0 0 1 1.6 6.334Zm8.482 4.6a5.933 5.933 0 1 1 .849-.848l2.493 2.492a.6.6 0 1 1-.849.849l-2.493-2.494Z",
      fill: "currentColor"
    })
  }));
};
export default SvgComponent;